import * as React from "react";
import {
    Text,
    StyleSheet,
    View,
    Dimensions,
    Image,
    TouchableOpacity,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import GlobalStyles from "../../components/GlobalStyles";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import FooterBarWide from "../../components/footerBarWide";
import Colors from "../../utilities/Color.js";
import { FontAwesome5 } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons';
import { getStatementByFilename, getStatementList } from "../../redux/actions/InvestActions";
import { useSelector } from "react-redux";
import { Platform } from "react-native";
import * as FileSystem from "expo-file-system";
import * as Sharing from "expo-sharing";

function openFileBlob(fileBlob) {
    if (Platform.OS == 'web') {
        let URI = URL.createObjectURL(fileBlob);
        window.open(URI, "_blank");
    } else {
        //native
        const fr = new FileReader();
        fr.onload = async () => {
            const fileURI = `${FileSystem.documentDirectory}/Statement.pdf`;
            await FileSystem.writeAsStringAsync(fileURI, fr.result.split(',')[1], { encoding: 'base64'});
            Sharing.shareAsync(fileURI);
        }
        // // await console.log(data);
        fr.readAsDataURL(fileBlob);
    }
}

function StatementListItem({ statement }) {
    const loadingIcon = require("../../assets/res/Loading_Screen_blue.gif");
    const [fileLoading, onChangeLoadState] = React.useState("a");
    if (statement != undefined) {
        // let statementPrefix = statement.path.split('/')[0];
        // let statementSuffix = statement.path.split('/')[3].split('(')[0].split('__')[1];
        let statementPrefix = "Annual Tax Statement";
        let statementSuffix = "2022-2023";
        return (
            <View style={styles.itemContainer}>
                <View style={styles.leftItemContainer}>
                    <Text style={styles.textStyle}>{`${statementPrefix}`}</Text>
                    <Text style={styles.textStyle}>{`${statementSuffix}`}</Text>
                </View>
                <View style={styles.rightItemContainer}>
                    {statement.blobLoaded ? <>
                        <TouchableOpacity
                            style={styles.iconContainer}
                            onPress={() => openFileBlob(statement.blob)}
                        >
                            <FontAwesome name="file" size={36} color={Colors.YELLOW} />
                            <Text style={styles.iconText}>Open</Text>
                        </TouchableOpacity>
                    </> : <>
                    {fileLoading == "a" ? 
                    <TouchableOpacity
                        style={styles.iconContainer}
                        onPress={() => {
                            onChangeLoadState("b");
                            getStatementByFilename(statement.path);
                        }}
                        >
                            <FontAwesome5 name="file-download" size={36} color={Colors.YELLOW} />
                            <Text style={styles.iconText}>Download</Text>
                        </TouchableOpacity>
                    : <></>}
                    {fileLoading == "b" ? 
                        <View style={styles.LoadingContainerIcon}>
                            <Image style={styles.loadingImage} source={loadingIcon} />
                        </View>
                    : <></>}
                    </>}
                </View>
            </View>
        );
    } else {
        return (
            <View style={styles.notAvailableContainer}>
                <View style={styles.iconContainer}>
                    <FontAwesome name="file" size={36} color={Colors.YELLOW} />
                </View>
                <View style={styles.notAvailText}>
                    <Text style={styles.textStyle}>Not Available - Issued EOFY</Text>
                </View>
            </View>
        )
    }
}

export default function StatementScreen() {
    const win = Dimensions.get("window");
    const statements = useSelector((state) => state.invest.statementList);
    const statementsLoaded = useSelector((state) => state.invest.statementListLoaded);
    const loadingIcon = require("../../assets/res/Loading_Screen_blue.gif");

    React.useEffect(() => {
        if (!statementsLoaded) {
          getStatementList();
        }
    }, [
        statementsLoaded,
        statements
    ]);

    return (
        <View style={GlobalStyles.containerW}>
            <ScrollView style={styles.scrollArea}>
                {win.width > 768 ? (
                    <View style={GlobalStyles.fullHeaderBarY}>
                        <MenuBar data="" />
                        <View style={GlobalStyles.headerContainerKLYellow}>
                            <View style={GlobalStyles.headerTextYellow}>
                                <Text style={GlobalStyles.headingStyle}>Statements</Text>
                                <Text style={GlobalStyles.subheaderStyleWeb}>
                                    Access your annual account statements when available.
                                </Text>
                            </View>
                        </View>
                    </View>
                ) : (
                    <View style={GlobalStyles.fullHeaderBarW}>
                        <StatusBar data="BM" />
                        <View style={GlobalStyles.headerContainerKL}>
                            <View style={GlobalStyles.headerText}>
                                <Text style={GlobalStyles.headingStyle}>Statements</Text>
                                <Text style={GlobalStyles.subheaderStyle}>
                                    Access your annual account statements when available.
                                </Text>
                            </View>
                        </View>
                    </View>
                )}
                {win.width > 768 ? (
                    <View style={GlobalStyles.adjustableBodyContainer}>
                        <View style={styles.headerContainer} >
                            <View style={styles.leftItemContainer}>
                                <Text style={styles.headertextStyle}>
                                    Tax Reports
                                </Text>
                            </View>
                            <View style={styles.rightItemContainer}>
                                <Text style={styles.headertextStyle}>
                                    
                                </Text>

                            </View>
                        </View>
                        {/* <StatementListItem /> */}
                        {statementsLoaded ? <>
                            {statements.map((statement, index) => {
                                return (
                                    <StatementListItem key={`statement#${index}`} statement={statement} />
                                )
                            })}
                        </> : <>
                            <View style={styles.LoadingContainer}>
                                <Image style={styles.loadingImage} source={loadingIcon} />
                           </View>
                        </>}
                        
                    </View>
                ) : (
                    <View style={GlobalStyles.adjustableBodyContainer}>
                        <View style={styles.headerContainer} >
                            <View style={styles.leftItemContainer}>
                                <Text style={styles.headertextStyle}>
                                    Tax Reports
                                </Text>
                            </View>
                            <View style={styles.rightItemContainer}>
                                <Text style={styles.headertextStyle}>
                                    
                                </Text>
                            </View>
                        </View>
                        {statementsLoaded ? <>
                            {statements.map((statement, index) => {
                                return (
                                    <StatementListItem key={`statement#${index}`} statement={statement} />
                                )
                            })}
                        </> : <>
                            <View style={styles.LoadingContainer}>
                                <Image style={styles.loadingImage} source={loadingIcon} />
                           </View>
                        </>}
                    </View>
                )}
            </ScrollView>
            <View style={GlobalStyles.webFooter}>
                {win.width > 768 ? <FooterBarWide /> : null}
            </View>
        </View>
    );
}
const styles = StyleSheet.create({
    scrollArea: {
        backgroundColor: "#ffffff",
    },
    subheaderStyle: {
        fontFamily: "montserrat-italic",
        fontSize: 12,
        color: "#776c7e",
        textAlign: "left",
        marginBottom: 5,
        paddingRight: 20,
        maxWidth: 300,
    },
    itemContainer: {
        flex: 1,
        flexDirection: "row",
        padding: 15,
        paddingLeft: 0,
        borderBottomWidth: 1,
        borderBottomColor: Colors.MIDGRAY,
        paddingBottom: 20,
    },
    leftItemContainer: {
        flex: 3,
        justifyContent: "flex-start",

    },
    rightItemContainer: {
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
        alignSelf: "center",
    },
    notAvailText: {
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
        alignSelf: "center",
        paddingTop: 20,
    },
    headerContainer: {
        flex: 1,
        flexDirection: "row",
        borderTopWidth: 0,
        borderBottomWidth: 1,
        paddingTop: 10,
        paddingBottom: 10,
        marginBottom: 10,
        borderColor: Colors.MIDGRAY
    },
    textStyle: {
        color: "#333333",
        fontFamily: "montserrat-medium",
        textAlign: "left",
        fontSize: 16,
        lineHeight: 20,
    },

    iconText: {
        color: "#333333",
        fontFamily: "montserrat-medium",
        textAlign: "center",
        fontSize: 9,
        lineHeight: 12,
    },
    headertextStyle: {
        fontFamily: "montserrat-bold",
        fontSize: 12,
        color: "#333333",
    },
    notAvailableContainer: {
        flex: 1,
        flexDirection: "column",
        padding: 15,
    },
    iconContainer: {
        alignItems: "center"
    },
    LoadingContainer: {
        height: "100%",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 50,
    },
    LoadingContainerIcon: {
        height: "100%",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        minHeight: 54,
    },
    loadingImage: {
        height: 25,
        width: 25,
    }
});
